import { Alignment } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { DataDisplayEvent, Label } from "@mcleod/components";
import { AutogenLayoutLtlCommodityLookup } from "./autogen/AutogenLayoutLtlCommodityLookup";

export class LtlCommodityLookup extends AutogenLayoutLtlCommodityLookup {
    labelHazmatOnDataDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        label.text = null;
        if (event.rowData?.get("is_hazmat") === "Y") {
            label.imageName = ImageName.warning;
            label.imageColor = "red";
            label.imageAlign = Alignment.LEFT;
        }
    }
}
